import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import RestService from "./../../Restservice";
import CustomTable from "./../../component/CustomTable";
import Loader from "./../../component/Loader";
import GlobalHelmet from "./../../GlobalHelmet";
import Breadcrumbs from "./../../component/breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Common from "./../../common.json";
const EditOption = React.lazy(() => import("./../../component/EditOption"));

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

export default function SignalStock() {
  let userParams = useParams();
  const screener_id = userParams.screener_id ? userParams.screener_id : 0;
  const sector_id = userParams.sector_id ? userParams.sector_id : 0;

  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  const mobile = userdata.mobile ? userdata.mobile : "";
  const web_token = userdata.web_token ? userdata.web_token : "";
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);
  const [signalName, setsignalName] = useState("");
  const [ntime, setntime] = useState(false);

  useEffect(() => {
    setLoading(true);
    RestService.getgetFundamentalScreenerStock(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        if (response.data) {
          setglobaldata(response.data.response);
          setsignalName(response.data.response.signalName);
        }
      },
      mobile,
      web_token,
      screener_id,
      sector_id
    );
  }, [mobile, web_token, screener_id, sector_id, ntime]);

  function refreshPage() {
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  }
  console.log("globaldata?.response?.metaData", Common?.fundamentalScreener);
  return (
    <>
      <GlobalHelmet {...Common?.fundamentalScreener} />
      <Helmet>
        <title>{globaldata?.metaData?.metatitle}</title>
        <meta
          property="og:title"
          content={globaldata?.metaData?.metatitle}
        ></meta>
        <meta
          name="description"
          content={globaldata?.metaData?.metaDescription}
        />
        <meta name="keywords" content={globaldata?.metaData?.metaKeyword} />
      </Helmet>

      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <div className="fixedAddButton">
                <Link
                  to="/fundamental-analysis"
                  className="btn btn-success mr-1"
                  title="Edit Column"
                >
                  <i className="fa fa-arrow-left"></i>
                </Link>
                <button
                  className="btn btn-success mr-1"
                  title="Reload Page"
                  onClick={refreshPage}
                >
                  <i className="fa fa-refresh"></i>
                </button>
                <EditOption />
              </div>
              <Breadcrumbs
                page={
                  '<a href="/fundamental-analysis/"> Fundamental Screener </a> :<span className="highlighttext">' +
                  signalName +
                  " </span> "
                }
              />

              <div className={classes.root}>
                <div className="">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="tabelcontiner">
                        <div className="row mb-3">
                          <div className="col-12 text-right"></div>
                        </div>
                        {!globaldata.getDetails ? (
                          ""
                        ) : (
                          <>
                            <CustomTable
                              key={globaldata.setColumn.dataField}
                              columndata={
                                globaldata.setColumn ? globaldata.setColumn : ""
                              }
                              marketdata={
                                globaldata.getDetails
                                  ? globaldata.getDetails
                                  : ""
                              }
                              redirectlink="/stocks/"
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
